export const VDP_IntegrationTypes: {
  [key: 'homenet' | 'ipacket' | 'salespages' | 'jdpower' | string]: {
    value: string;
    label: string;
  };
} = {
  homenet: { value: 'homenet', label: 'HomeNet' },
  ipacket: { value: 'ipacket', label: 'iPacket' },
  jdpower: { value: 'jdpower', label: 'JDPower' },
  salespages: { value: 'salespages', label: 'Landing Page' },
};
